{
  "common": {
    "continue": "CONTINUE",
    "back": "Back",
    "ok": "OK",
    "point_phone_totem": "Point your phone at the portal on the totem",
    "skip_step": "SKIP STEP",
    "confirm": "CONFIRM",
    "your_answer": "YOUR ANSWER",
    "required_answer": "YOU NEED TO WRITE AN ANSWER",
    "insert_keyword": "Enter the keyword correctly to deactivate the system"
  },

  "intro": {
    "point_phone_totem":"Point your phone at this image",
    "target_title": "To begin, the system needs to detect you.",
    "target_text": "Point your device at the totem with the image above.",

    "story_1_title": "A dimensional collapse is happening at <span class=\"highlight-white\">gamescom latam.</span>",
    "story_1_text": "The portals of the four worlds — <span class=\"highlight-white\">Hero, Shadow, Neo and Open</span> — are becoming unstable. Fragments of reality are spreading across the event.",

    "story_2_title": "You have been chosen as the Guardian of the Portals.",
    "story_2_text": "Your mission: travel through the worlds, solve riddles and prove that you understand the essence of each one.",

    "story_3_title": "With each success, a fragment is collected.",
    "story_3_text": "In the end, the key to the Grand Prize will be revealed.",
    "story_3_call": "Do you accept the call?",

    "prizes_intro": "These are the possible rewards for restoring the balance of our worlds. Move forward, Guardian.",
    "prize_exclusive_items": "EXCLUSIVE ITEMS",
    "prize_list_item_1": "EXCLUSIVE GAMESCOM LATAM WORLDS T-SHIRT",
    "prize_list_item_2": "EXCLUSIVE GAMESCOM LATAM WORLDS MUG",
    "prize_list_item_4": "EXCLUSIVE GAMESCOM LATAM BOTTLE",
    "prize_list_item_5": "EXCLUSIVE GAMESCOM LATAM PINS",
    "prizes_warning": "And more! Check the complete list at the gift pick-up area at Ponto Epix, on Str B between Str 5 and 6, near the B2B area. Remember, gifts are subject to stock availability.",

    "form_title": "The dimensional system has detected you.",
    "form_text_1": "Before crossing the portals, we need to know who the Guardian is.",
    "form_text_2": "Register yourself. Your journey begins now.",
    "guardian_data": "Guardian Data",

    "name_label": "NAME",
    "name_placeholder": "Name",
    "gender_label": "GENDER",
    "gender_placeholder": "Select",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_other": "Other",
    "birthdate_label": "DATE OF BIRTH",
    "birthdate_placeholder": "00/00/0000",
    "document_label": "CPF | PASSPORT",
    "email_label": "E-MAIL",
    "email_placeholder": "E-MAIL",
    "accept_terms": "Accept the terms of use",

    "tutorial_text_1": "You will face riddles from each world. Some will require keywords hidden in <span class=\"highlight-white\">gamescom latam.</span>",
    "tutorial_text_2": "Others will test your knowledge about the universes you love. <span class=\"highlight-white\">Stay alert!</span>",

    "zone_intro_title": "The first portal opens. A dense fog hides ancient creatures.",
    "zone_intro_text": "To cross, you must find the word that echoes like a silent scream. You feel colder air coming from the <span style=\"color:#AD4CFF\">Shadow Zone.</span>"
  },

  "shadowzone": {
      "point_phone_totem": "Point your phone at this image",
    "target_title": "You need to find the secret word to proceed.",
    "target_text": "Use augmented reality to identify the hidden image in the Shadow Zone.",

    "success_title": "You hear your voice echoing in distortion",
    "success_text": "The fog dissipates, the path to a fragment becomes clear and you recover it.",

    "failure_title": "The word has no effect and the fog seems even denser.",
    "failure_text": "Try again, Guardian.",

    "option_a_title": "Experience this game like never before at gamescom latam right now!",
    "synopsis_placeholder": "Explore a reimagined Gotham in a unique way, where the classic LEGO humor meets the epic atmosphere of the Dark Knight in an unforgettable journey across generations of heroism.",
    "visit_text": "<span class=\"highlight-hero bold\">Visit the Warner Games booth!</span>",
    "address": "Str E, corner of Str 3. For more information, consult the official map.",

    "zone_intro_title": "The second portal opens. The dystopian atmosphere with unimaginable technologies and neon-colored cities feels strangely familiar.",
    "zone_intro_text": "The system in front of you is corrupted. To bypass the defense protocols and find one of the fragments, you need the access word that only true rebels know. Following data trails, you move toward the <span class=\"highlight-neo\">Neo Zone</span>."
  },

 "neozone": {
  "point_phone_totem": "Point your phone at this image",
  "target_title": "The word must be hidden in the Neo Zone.",
  "target_text": "Use your smartphone to track it. Turn on your camera and look around.",

  "success_title": "The glitch has been resolved",
  "success_text": "With the system stabilized, the fragment manifests within your reach",

  "failure_title": "Incorrect code. The alarm is triggered.",
  "failure_text": "Try again, Guardian.",

  "question_title": "Guardian, your journey through the worlds demands a perception that challenges the limits of the ordinary.",
  "question_prompt": "To restore balance and dissipate the fog of chaos, you must access the force that sustains this multiverse: <span class=\"highlight-neo-regular\">GeForce RTX technologies</span>, which are revolutionizing gaming.",

  "question_title_2": "Break free from the constraints of latency.",
  "question_prompt_2": "Here, the flow of worlds is constant, allowing complete immersion where lag does not exist and fluidity is absolute. Since the rise of DLSS 4 with its Transformer models, we have redefined reality. <span class=\"highlight-neo-regular\">Now, with the new DLSS 4.5 Super Resolution, sharpness reaches a divine level through second-generation AI models,</span> available to all GeForce RTX GPU users.",
  "question_prompt_3": "For those seeking supremacy with GeForce RTX Series 50 GPUs, time bends to your will: <span class=\"highlight-neo-regular\">Dynamic Multi Frame Generation expands reality up to 6 times more frames,</span> ensuring your senses never miss a single detail.",

  "question_option_a": "<span class=\"highlight-white\">A)</span> YES (Go visit the <span class=\"highlight-neo\">NVIDIA BOOTH</span>)",
  "question_option_b": "<span class=\"highlight-white\">B)</span> NO (Continue the adventure)",

  "option_a_title": "The next fragment of your evolution awaits you.",
  "synopsis": "Cross digital boundaries and <span class=\"highlight-neo\">visit the NVIDIA booth at gamescom latam</span> to witness the forging of visual perfection and the fluidity that guides the future.",
  "address": "Str E, corner of Str 2. For more information, consult the official map.",
  "option_a_button": "EVALUATE THE NVIDIA EXPERIENCE",

  "review_intro": "After experiencing this technological universe",
  "review_title": "Share your impressions about the NVIDIA Booth",
  "rating": {
    "gamesSelection": "GAME SELECTION",
    "lines": "LINES",
    "gift": "GIFTS",
    "service": "SERVICE"
  },

  "review_optional": "DID YOU MISS ANYTHING? <span class=\"highlight-white\">TELL US</span>",
  "review_confirm": "CONFIRM",

  "zone_intro_title": "The portal shows you a place where possibilities are infinite",
  "zone_intro_text": "you see the fragment, in a place out of reach. Already understanding the innate power of words, you move on to the <span class=\"highlight-open\">Open Zone</span>."
},
  "openzone": {
      "point_phone_totem": "Point your phone at this image",
    "target_title": "Reality is yours to shape.",
    "target_text": "Find the word in the Open Zone.",

    "success_title": "Obeying your command",
    "success_text": "Blocks assemble into a staircase toward the fragment. The world recognizes its creator.",

    "failure_title": "When casting the word, the structure collapses",
    "failure_text": "Start again",

    "option_a_title": "Feel the weight of a true hero’s legacy in the multiverse of<span class=\"highlight-hero-bigger\"> Invincible</span>",
    "synopsis_placeholder": "Face global-scale threats and prove your strength is necessary to protect reality. A visceral combat experience that challenges everything you know about heroes and villains awaits you.",
    "visit_text": "<span class=\"highlight-hero bold\">Visit the Invincible VS booth and prove your worth!</span>",
    "address": "Str 5, corner of Str F. For more information, consult the official map.",
    "question_prompt": "It’s time to review your battles and honestly evaluate your experience",
    "review_title": "Share your impressions about INVINCIBLE VS",
    "review_optional": "WANT TO SAY SOMETHING ABOUT <span class=\"highlight-white\">INVINCIBLE VS</span>?",

    "rating": {
      "graphics": "GRAPHICS",
      "gameplay": "GAMEPLAY",
      "fun": "FUN",
      "challenge": "CHALLENGE",
      "ambience": "AMBIENCE"
    },

    "extra_title": "Dive into a world where ancient martial arts meet steam-powered machines in a breathtaking visual spectacle",
    "extra_synopsis": "In <span class=\"highlight-white\"> Phantom Blade Zero </span>, you are an elite assassin in a race against time to uncover dark conspiracies and restore honor in a brutal and fascinating 'Kungfupunk' universe.",
    "extra_highlight": "EXPERIENCE THIS GAME LIKE NEVER BEFORE AT GAMESCON LATAM RIGHT NOW!",
    "extra_cta": "Visit the booth and master the phantom blade!",
    "extra_button": "CONTINUE",

    "zone_intro_title": "Final portal: The <span class=\"highlight-hero-bigger\">Hero Zone </span> is revealed. An ancient legend calls for your help",
    "zone_intro_text": "To inscribe runes on your legendary sword, seek the word that will grant you unlimited power. In the heart of the <span class=\"highlight-hero\">Hero Zone</span>, the words of power are hidden"
  },

  "herozone": {
      "point_phone_totem": "Point your phone at this image",
    "target_title": "You are approaching the end. Use your smartphone to locate the word.",
    "target_text": "The place to find it is in the Hero Zone.",

    "success_title": "As you inscribe the word on the sword, it returns to its original form",
    "success_text": "It transforms into one of the fragments you seek",

    "failure_title": "You inscribe the word",
    "failure_text": "But as soon as you finish, it disappears and nothing happens. Try again",

    "option_a_title": "Worlds collide and Earth’s greatest heroes need a new command",
    "option_a_button": "CONTINUE",

    "synopsis_placeholder": "Join the Avengers and the Guardians in this convergence of extraordinary powers to stop a threat that crosses dimensions. Justice needs you so balance can be restored at gamescom latam.",
    "visit_text": "Experience this game like never before at gamescom latam right now!",
    "address": "Explore Marvel Tokon early in the <span class=\"highlight-hero\">Hero Zone!</span>",

    "zone_intro_title": "Closing your eyes, you feel the energy of the fragments responding to unstable portals.",
    "zone_intro_text_1": "Manipulating the energies of each fragment <span class=\"highlight-hero\">you simultaneously open the four portals, surrounding you in pure chaos.</span>",
    "zone_intro_text_2": "Each word you learned returns to your memory, and as you declare them in order, chaos gives way to balance.<span class=\"highlight-hero\"> Your duty as Guardian has been fulfilled.</span>"
  },

  "final": {
    "survey_intro": "The portals are stable again and the paths between worlds are safe. But before receiving your reward, the Council of Worlds wants to know:",
    "survey_title": "Why did you come this far?",

    "rating_title": "Rate the overall experience from 1 to 5.(1 to 5)",

    "question_why_title": "2 - What motivated you to reach the end?",
    "question_why_option_a": "<span class=\"highlight-white\">A)</span> The story",
    "question_why_option_b": "<span class=\"highlight-white\">B)</span> The reward",
    "question_why_option_c": "<span class=\"highlight-white\">C)</span> Doing the activity with friends",
    "question_why_option_d": "<span class=\"highlight-white\">D)</span> Curiosity",

    "question_world_title": "3 - Which world did you like the most?",
    "question_world_option_a": "<span class=\"highlight-white\">A)</span> <span class=\"highlight-shadow\">Shadow Zone</span>",
    "question_world_option_b": "<span class=\"highlight-white\">B)</span> <span class=\"highlight-neo\">Neo Zone</span>",
    "question_world_option_c": "<span class=\"highlight-white\">C)</span> <span class=\"highlight-hero\">Hero Zone</span>",
    "question_world_option_d": "<span class=\"highlight-white\">D)</span> <span class=\"highlight-open\">Open Zone</span>",

    "review_optional": "Leave a comment for our team",

    "survey_continue": "CONTINUE",
    "survey_modal_text": "Your answers will be recorded in the Great Chronicle of Guardians",

    "success_title": "gamescom latam has been saved!",
    "success_text": "You, Guardian, restored the balance of the four portals. Now, the Council of Worlds grants you your reward",

    "success_text_highlight": "You restored the balance of the portals",

    "final_code_label": "Here is your completion code",
    "final_code_help": "Head to the prize pick-up area, located at Ponto Epix, on Str B between Str 5 and Str 6, near the B2B area, and collect your prizes. May your legend inspire others!",

    "final_error_text": "Error sending code",
    "final_retry_button": "TRY AGAIN"
  }
}